import * as React from 'react'
import { Button } from 'reactstrap'
import { useModal } from '@components/modals/use-modal'

export const BenefitProgramCreateButton: React.FC = () => {
  const [toggleModal] = useModal('BenefitProgramCreateModal')

  return (
    <Button onClick={toggleModal} color="green-dark" type="button">
      <i className="mdi mdi-plus-circle mr-1" />
      Dodaj pracodawcę
    </Button>
  )
}
